import { ApiProperty } from '@nestjs/swagger';

export class VdPdfGeneralInfoDto {
  @ApiProperty({ example: 301 })
  numeroLiquidacion!: number;

  @ApiProperty({ example: 'ACOGRAPES' })
  cliente!: string;

  @ApiProperty({ example: 'FEBRERO' })
  mesLiquidacion!: string;

  @ApiProperty({ example: '2025-02-01' })
  dateFrom!: string;

  @ApiProperty({ example: '2025-02-28' })
  dateTo!: string;

  @ApiProperty({ example: 5 })
  contenedores!: number;

  @ApiProperty({ example: 'OPB', enum: ['OPB', 'A&O'] })
  centroCosto!: 'OPB' | 'A&O';
}

export class VdPdfResumenOperacionDto {
  @ApiProperty({ example: 2121.0, description: 'Suma VDCliente en USD' })
  vdUsd!: number;

  @ApiProperty({ example: 2058429, description: 'Suma CLPNetoCliente en CLP' })
  vdClp!: number;

  @ApiProperty({
    example: 0,
    description: 'Suma descuentos (Tipo=2) en USD para OPB, 0 para A&O',
  })
  descuentoNetoUsd!: number;

  @ApiProperty({
    example: 0,
    description: 'Suma descuentos (Tipo=2) en CLP para OPB, 0 para A&O',
  })
  descuentoNetoClp!: number;

  @ApiProperty({ example: 2121.0, description: 'OPB: VD - Descuento; A&O: 0' })
  netoUsd!: number;

  @ApiProperty({ example: 2058429, description: 'OPB: VD - Descuento; A&O: 0' })
  netoClp!: number;

  @ApiProperty({ example: 402.99, description: 'OPB: Neto * 0.19; A&O: 0' })
  ivaUsd!: number;

  @ApiProperty({ example: 391101, description: 'OPB: Neto * 0.19; A&O: 0' })
  ivaClp!: number;

  @ApiProperty({ example: 2523.99, description: 'OPB: Neto + IVA; A&O: 0' })
  brutoFacturaUsd!: number;

  @ApiProperty({ example: 2449530, description: 'OPB: Neto + IVA; A&O: 0' })
  brutoFacturaClp!: number;

  @ApiProperty({
    example: 0,
    description: 'Suma inst. financiera (Tipo=1) en USD',
  })
  instruccionFinancieraUsd!: number;

  @ApiProperty({
    example: 0,
    description: 'Suma inst. financiera (Tipo=1) en CLP',
  })
  instruccionFinancieraClp!: number;

  @ApiProperty({
    example: 2523.99,
    description: 'OPB: Bruto - IF; A&O: VD - IF',
  })
  totalPagarUsd!: number;

  @ApiProperty({
    example: 2449530,
    description: 'OPB: Bruto - IF; A&O: VD - IF',
  })
  totalPagarClp!: number;
}

export class VdPdfParticipacionItemDto {
  @ApiProperty({ example: 'MAERSK CHILE S.A.' })
  nombre!: string;

  @ApiProperty({ example: 11 })
  porcentaje!: number;

  @ApiProperty({ example: 18 })
  contenedores!: number;
}

export class VdPdfParticipacionDto {
  @ApiProperty({ example: 156 })
  totalContenedores!: number;

  @ApiProperty({ type: [VdPdfParticipacionItemDto] })
  porNaviera!: VdPdfParticipacionItemDto[];

  @ApiProperty({
    type: [VdPdfParticipacionItemDto],
    required: false,
    description:
      'Opcional: participación por tráfico mes (p.ej., FAR EAST, EAST COAST) si existe en datos',
  })
  porTrafico?: VdPdfParticipacionItemDto[];
}

export class LiquidacionVdPdfPage1Dto {
  @ApiProperty({ type: VdPdfGeneralInfoDto })
  general!: VdPdfGeneralInfoDto;

  @ApiProperty({ type: VdPdfResumenOperacionDto })
  resumen!: VdPdfResumenOperacionDto;

  @ApiProperty({ type: VdPdfParticipacionDto })
  participacion!: VdPdfParticipacionDto;
}
